<template>
  <div class="w-full home-container">
      <Header/>
        <div class="text-3xl pt-4 pb-4 text-center font-semibold"> Loading ...</div>
  </div>
</template>
<script>
import Header from '@/shared/components/layout/Header'
import store from '@/store/index'
export default {
  name: "Home",
  beforeRouteEnter: async (to, from, next) => {
    document.title = "Expert Sourcing: BuyHive Limited";
    console.log('user details',store.getters.isUserLoggedIn, store.getters.getUserAuthInfo.role)
    if (
      store.getters.isUserLoggedIn &&
      store.getters.getUserAuthInfo.role != "buyer"
    ) {
      console.log('user details if || home',store.getters.isUserLoggedIn, store.getters.getUserAuthInfo.role)
      next({ name: "EmailVerification" });
    } else {
      console.log('user details else || home',store.getters.isUserLoggedIn, store.getters.getUserAuthInfo.role)
      window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`;
    }
  },

  components: {
    Header,
  },
  computed: {
    // baseURL() {
    //   return process.env.VUE_APP_SERVER_BASE_URL;
    // },
    // sourcingURL() {
    //   return (
    //     process.env.VUE_APP_SOURCING_REPORT_OFFERING_PAGE + "#reportoffering"
    //   );
    // },
    // linkFreelancer() {
    //   return process.env.VUE_APP_SERVER_BASE_URL + "/become-a-freelancer";
    // },
  },
  data: () => ({
    sampleReport: process.env.VUE_APP_SAMPLE_FILE_REPORT,
    feautredCategories: [],
    featuredFreelancers: [],
    end_date: process.env.VUE_APP_END_DATE,
    date_suffix: process.env.VUE_APP_DATE_SUFFIX,
    end_date_month: process.env.VUE_APP_END_DATE_MONTH,
  }),

  created() {
    // this.handleFetchTop9Categories();
    // this.handleFetchFeturedFreelancers();
  },
  methods: {
    // async handleFetchTop9Categories() {
    //   const data = await this.fetchTop9Category();
    //   if (data.result) {
    //     this.feautredCategories = data.categories;
    //   }
    // },
    // getBookACallUrl() {
    //   window.open(process.env.VUE_APP_BOOK_A_CALL_URL, "_blank");
    // },
    // redirectToBuyerRegister() {
    //   if (this.$store.getters.getUserAuthInfo.role !== "buyer") {
    //     window.location = `${this.baseURL}/buy/register`;
    //   }
    // },
    // onEnter(e) {
    //   e.preventDefault();
    //   const url = `${this.baseURL}/buy/sourcing-request`;
    //   window.location.href = url;
    // },
    // async handleFetchFeturedFreelancers() {
    //   const data = await this.fetchFeaturedFreelancer();
    //   if (data.result) {
    //     this.featuredFreelancers = data.freelancers;
    //   }
    // },

    // handleViewAllButton() {
    //   this.$router.push({ name: "FreelancerList" });
    // },
    // handleFreelancerRedirect() {
    //   this.$router.push({ name: "Register" });
    // },
  },
};
</script>
<style lang="scss" scoped>
.home-container {
  :deep().carousel__next {
    transform: translate(60%, -50%);
    @screen md {
      transform: translate(120%, -50%);
    }
  }
  :deep().carousel__prev {
    transform: translate(-60%, -50%);
    @screen md {
      transform: translate(-120%, -50%);
    }
  }
  :deep().carousel__pagination-button {
    @apply rounded-3xl bg-white bg-black border-black;
    height: 12px;
    width: 12px;
    border: 1px solid #c4c4c4;
  }
  :deep().carousel__pagination-button--active {
    height: 12px;
    width: 12px;
    background-color: #4c5965;
  }
  :deep().carousel__pagination {
    @apply pt-2;
  }
}

.learn-more {
  font-size: 22px;
  line-height: 26.4px;
  background-color: #201b57;
}
.learn-more-sm {
  font-size: 18px;
  line-height: 27px;
  background-color: #8bc53f;
  width: 124px;
  height: 47px;
}
.find-an-expert {
  @screen sm {
    font-size: 20px;
    line-height: 28px;
  }
  @screen md {
    font-size: 20px;
    line-height: 28px;
  }
  @screen lg {
    font-size: 22px;
    line-height: 30.8px;
  }
}
.image-gradient {
  background: linear-gradient(0deg, #000000, rgba(32, 27, 87, 0) 20%);
  height: 690px;
  @screen md {
    background: linear-gradient(176deg, #000000 0%, rgba(0, 0, 0, 0) 20%);
    height: 725px;
  }
}
.talk-to-us {
  padding-top: 4rem;
  background-color: #231f20f7;
  color: white;
}
.talk-to-us-header {
  font-size: 48px;
  line-height: 56.7px;
  font-family: "Avenir LT Pro";
  font-weight: 700;
}
.talk-to-us-content {
  font-size: 20px;
  line-height: 30px;
  font-family: "Avenir LT Pro";
}
.new-app-btn {
  @apply rounded-full px-8 py-2 text-white;
  font-size: 24px;
  line-height: 40px;
  font-family: "Avenir LT Pro";
  font-weight: 600;
}
.image-banner {
  @apply w-full bg-center bg-no-repeat bg-cover;
  background-image: url("../../../assets/images/Freelancer_mobile_banner.png");
  height: 690px;
  @screen lg {
    background-image: url("../../../assets/images/background_banner.png");
    height: 725px;
  }
  @screen md {
    background-image: url("../../../assets/images/background_banner.png");
  }
}
.dynamic-sourcing-section {
  @apply h-auto;
  @screen lg {
    height: 575px;
    img {
      width: 675px;
      height: 470px;
    }
  }
  &-color {
    background: linear-gradient(98.67deg, #29b574 27.61%, #00b3c9 95.42%);
  }
}
.dynamic-sourcing-section-color-sm {
  background: white;
  color: black;
}
.dynamic-report-text {
  @screen lg {
    padding-left: 1.5rem;
    font-size: 24px;
    line-height: 36px;
  }
}
.dynamic-report-text-sm {
  font-size: 18px;
  line-height: 27px;
  // color: #231F2099;
}
.sourcing-expertise {
  @apply h-auto;
  @screen lg {
    height: 617px;
  }
  .text-section {
    height: 420px;
    @screen lg {
      @apply h-full;
    }
  }
}
.testimonials {
  background-color: #8bc53f26;
}
.dynamic-report-header {
  @screen lg {
    font-size: 26px;
    line-height: 31.2px;
  }
}
.dynamic-report-header-sm {
  font-size: 20px;
  line-height: 22px;
  color: #231f2099;
  padding-bottom: 2rem;
}
.buyer-freelancer {
  color: #231f2099;
  padding-top: 2.5rem;
  @screen md {
    font-size: 20px;
    line-height: 24px;
  }
  @screen lg {
    font-size: 24px;
    line-height: 28.8px;
  }
}
.find-an-expert-btn {
  line-height: 30px;
}
.banner-header {
  font-size: 40px;
  line-height: 44px;
}
.banner-text {
  @screen lg {
    line-height: 72px;
  }
}
.sourcing-image {
  background-image: url("../../../assets/images/cheerful-young-man.svg");
  @apply bg-no-repeat bg-cover h-60 sm:h-114-25 lg:h-full lg:w-full;
  position: relative;
  // @screen md {
  //   height: 15rem;
  // }
}
// .sourcing-image {
//   width: 0;
//   height: 0;
//   border-left: 50px solid transparent;
//   border-right: 50px solid transparent;
//   border-bottom: 50px solid black;
// }
.banner-content {
  // @screen sm {
  font-size: 40px;
  line-height: 44px;
  // }
  @screen lg {
    font-size: 60px;
    line-height: 72px;
  }
}
.buyer-freelancer-text {
  @screen lg {
    font-size: 24px;
    line-height: 28.8px;
  }
  font-size: 16px;
  line-height: 19.2px;
}
.sourcing-expertise-content {
  position: relative;
  overflow: visible;
}
.triangle {
  @screen md {
    margin-bottom: -1.1rem;
  }
  z-index: 1;
  position: absolute;
  top: -1.5rem;
  width: 0;
  left: 47%;
  height: 0;
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
  border-bottom: 25px solid #4c5965;
}
.triangle-lg {
  z-index: 1;
  position: absolute;
  width: 0;
  left: -2.5rem;
  height: 0;
  border-top: 35px solid transparent;
  border-bottom: 35px solid transparent;
  border-right: 45px solid #4c5965;
}
</style>